import { render, staticRenderFns } from "./Boutique.vue?vue&type=template&id=679958e6&lang=html"
import script from "./Boutique.vue?vue&type=script&lang=js"
export * from "./Boutique.vue?vue&type=script&lang=js"
import style0 from "./Boutique.vue?vue&type=style&index=0&id=679958e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports